module.exports = __webpack_public_path__ + "img/pantalla-6-3-1.4efb4d8e.png";